import { computed } from '@angular/core';
import { signalStore, withComputed, withState } from '@ngrx/signals';
import { withCrudMethods } from '../../store/crud.feature';
import { CallService } from '../../services';
import { initialState } from '../../store/initial-state';
import { Call } from '../../model';

const initCallState = initialState<Call>();

export const CallStore = signalStore(
  { providedIn: 'root' },
  withState(initCallState),
  withCrudMethods(CallService),
  withComputed(({ entities }) => ({
    ev: computed(() => entities().sort((a, b) => b.id - a.id).slice(0, 20)),
  })),
);
